import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { postTags, updateTags } from "./tags";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  videos: [],
  singleVideo: {},
  fetchLoading: false,
};

const slice = createSlice({
  name: "video",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: success post blog

    postVideoSuccess(state, action) {
      state.isLoading = false;
      // state.videos = [...state.videos, action.payload];
    },
    // TODO: successFetch blog

    getVideoSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.videos = action.payload;
    },

    // TODO: single blog fetch success

    getSingleVideoSucess(state, action) {
      state.isLoading = false;
      state.singleVideo = action.payload;
    },

    // Update blog
    updateVideoSuccess(state, action) {
      state.isLoading = false;
      // state.videos = state.videos?.map((video) => {
      //   if (video.slug === action.payload.slug) {
      //     return action.payload;
      //   } else {
      //     return video;
      //   }
      // });
    },

    // delete blog
    deleteVideoSuccess(state, action) {
      state.isLoading = false;
      // state.videos = state.videos.filter(
      //   (video) => video.id !== action.payload
      // );
    },
  },
});

export default slice.reducer;

export function getVideos({ categoryId, limit = 5, page = 1, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`items`, {
        params: {
          limit,
          page: page + 1,
          category_slug: categoryId,
          season_id,
        },
      });
      dispatch(
        slice.actions.getVideoSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateVideo({ slug, data, enqueueSnackbar, tagData, tag_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items/${slug}`, data);
      if (
        tagData?.team ||
        tagData?.player ||
        tagData?.game ||
        tagData?.category
      ) {
        if (tag_id) {
          dispatch(
            updateTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
              tag_id,
            })
          );
        } else {
          dispatch(
            postTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
            })
          );
        }
      }

      dispatch(slice.actions.updateVideoSuccess(response.data.data));
      enqueueSnackbar("Video is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postVideos({ data, enqueueSnackbar, navigate, tagData }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items`, data);
      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );
      dispatch(slice.actions.postVideoSuccess(response.data.data));
      enqueueSnackbar("Video is created successfully");
      navigate(PATH_DASHBOARD.videohub.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVideo(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`items/${id}`);

      dispatch(slice.actions.getSingleVideoSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteVideo({
  id,
  enqueueSnackbar,
  categoryId,
  pagination,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`items/${id}`);
      dispatch(slice.actions.deleteVideoSuccess(id));
      dispatch(
        getVideos({
          categoryId,
          page: pagination.page,
          limit: pagination.limit,
          season_id,
        })
      );

      enqueueSnackbar("Video is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
